'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var classNames = require('classnames');
var Button_module = require('./Button.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var Button = function (_a) {
    var _b;
    var onClick = _a.onClick, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.secondary, secondary = _d === void 0 ? false : _d, _e = _a.displayType, displayType = _e === void 0 ? 'button' : _e, children = _a.children, props = tslib.__rest(_a, ["onClick", "className", "secondary", "displayType", "children"]);
    var onButtonClick = function (event) {
        event.preventDefault();
        onClick();
    };
    return (React__default["default"].createElement("button", tslib.__assign({ className: classNames__default["default"](className, Button_module["default"][displayType + "Button"], (_b = {},
            _b[Button_module["default"].primaryButton] = !secondary,
            _b[Button_module["default"].secondaryButton] = secondary,
            _b)), onClick: onButtonClick, type: "button" }, props), children));
};

exports["default"] = Button;
//# sourceMappingURL=Button.js.map
